import { AppProviders } from "context/AppProviders";
import AppRouter from "./routes/AppRouter";
import NetworkStatus from "utils/NetworkStatus";
import ScrollToTop from "components/CustomWidgets/scrollToTop";
import { useEffect, useState } from "react";
import Loader from "components/BaseWidgets/Loader";
import { onMessageListener, requestForToken } from "./firebase/firebase";
import AlertNotification from "components/CustomWidgets/alertNotification";
import SEO from "components/SEO";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getFcmToken = async () => {
      const token = await requestForToken();
    };
    getFcmToken();
  }, []);

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        const notificationTitle =
          payload?.notification?.title || "New Notification";
        const notificationBody =
          payload?.notification?.body || "You have a new message!";
        const notificationIcon =
          payload?.notification?.icon || "/firebase-logo.png";

        AlertNotification("info", notificationBody);

        // Browser native notification too:
        if (Notification.permission === "granted") {
          new Notification(notificationTitle, {
            body: notificationBody,
            icon: notificationIcon,
          });
        }
      })
      .catch((err) => console.error("FCM onMessage error: ", err));
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      // Block only on images
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <AppProviders>
      <NetworkStatus />
      {isLoading ? (
        <Loader spinning fullScreen />
      ) : (
        <>
          <AppRouter />
          <ScrollToTop />
        </>
      )}
    </AppProviders>
  );
}

export default App;
